export default __webpack_public_path__ + "static/media/Provimento-170_2016.c5902091.pdf";